import { SelectField } from '../SelectField';
import { useTranslator } from '~/translations/TranslatorContext';
import type { SelectFieldProps } from '../SelectField/types';

interface YesNoSelectProps {
    allowBlank?: boolean;
    isinvalid?: boolean;
    isInline?: boolean;
    isReadonly?: boolean;
    name?: string;
    onChange: SelectFieldProps['onChange'];
    onClose?: SelectFieldProps['onClose'];
    title?: string;
    tooltip?: string;
    type?: string;
    value?: boolean | null;
    validationMessage?: string | null;
}

export const YesNoSelect = (props: YesNoSelectProps) => {
    const {
        allowBlank,
        isinvalid = false,
        isInline = false,
        isReadonly = false,
        name,
        onChange,
        onClose,
        title,
        tooltip,
        type = 'yesno',
        value = null,
        validationMessage = null,
    } = props;

    const trans = useTranslator();

    const source = [
        { value: true, text: trans('yes') },
        { value: false, text: trans('no') },
    ];

    return (
        <SelectField
            allowBlank={allowBlank}
            isAutocomplete={false}
            isInline={isInline}
            isinvalid={isinvalid}
            isReadonly={isReadonly}
            multiSelect={false}
            name={name}
            onChange={(value) => onChange(value)}
            onClose={onClose}
            options={source}
            title={title}
            tooltip={tooltip}
            type={type}
            value={value === null ? null : value}
            validationMessage={validationMessage}
        />
    );
};
